"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDictionaryEvidence = void 0;
const react_1 = __importStar(require("react"));
const authored_evidence_1 = require("../authored-evidence/authored-evidence");
const dictionary_toolbar_1 = require("./dictionary-toolbar");
const dictionary_fields_1 = require("./dictionary-fields");
const dictionary_columns_1 = require("./dictionary-columns");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
function useDictionaryEvidence(options) {
    var _a, _b, _c, _d;
    const columns = dictionary_columns_1.useColumns({
        columns: (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.columns,
    });
    const defaultSorts = react_1.useMemo(() => { var _a, _b; return (_b = (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.defaultSorts) !== null && _b !== void 0 ? _b : [
        { field: 'order', datakey: 'order', order: 'ASC', type: 'FIELD' },
        { field: 'name', datakey: 'name', order: 'ASC', type: 'FIELD' },
    ]; }, [(_b = options.tableProps) === null || _b === void 0 ? void 0 : _b.defaultSorts]);
    const GeneralFieldsComponent = react_1.useMemo(() => function Fields() {
        var _a;
        return (react_1.default.createElement(dictionary_fields_1.DictionaryFields, { FieldsComponent: (_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.GeneralFieldsComponent }));
    }, [(_c = options.detailProps) === null || _c === void 0 ? void 0 : _c.GeneralFieldsComponent]);
    const toolbarProps = react_1.useMemo(() => {
        var _a;
        return ({
            after: react_1.default.createElement(dictionary_toolbar_1.DictionaryToolbar, null),
            ...(_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.toolbarProps,
        });
    }, [(_d = options.detailProps) === null || _d === void 0 ? void 0 : _d.toolbarProps]);
    const initNewItem = event_callback_hook_1.useEventCallback(() => {
        var _a, _b;
        const obj = {
            active: true,
        };
        if (((_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.initNewItem) !== undefined) {
            return {
                ...obj,
                ...(_b = options.detailProps) === null || _b === void 0 ? void 0 : _b.initNewItem(),
            };
        }
        else {
            return obj;
        }
    });
    return authored_evidence_1.useAuthoredEvidence({
        ...options,
        tableProps: {
            ...options.tableProps,
            columns,
            defaultSorts,
        },
        detailProps: {
            ...options.detailProps,
            initNewItem,
            GeneralFieldsComponent,
            toolbarProps,
        },
    });
}
exports.useDictionaryEvidence = useDictionaryEvidence;
//# sourceMappingURL=dictionary-evidence.js.map